import { render, staticRenderFns } from "./servicos-citados.vue?vue&type=template&id=5b1c22d8&scoped=true&"
import script from "./servicos-citados.vue?vue&type=script&lang=js&"
export * from "./servicos-citados.vue?vue&type=script&lang=js&"
import style0 from "./servicos-citados.vue?vue&type=style&index=0&id=5b1c22d8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c22d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1c22d8')) {
      api.createRecord('5b1c22d8', component.options)
    } else {
      api.reload('5b1c22d8', component.options)
    }
    module.hot.accept("./servicos-citados.vue?vue&type=template&id=5b1c22d8&scoped=true&", function () {
      api.rerender('5b1c22d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/servicos-citados/servicos-citados.vue"
export default component.exports